@switch (loadState()) {
  @case ('loading') {
    <p class="run-parameters__state" data-testid="module-run-params-loading">
      <mat-progress-spinner mode="indeterminate" diameter="16" aria-hidden="true" />
      {{ 'modules.run.parameters.loading' | translate }}
    </p>
  }
  @case ('failed') {
    <div class="run-parameters__state run-parameters__state--error" role="alert" data-testid="module-run-params-error">
      <mat-icon aria-hidden="true">error</mat-icon>
      <span>{{ 'modules.run.parameters.loadFailed' | translate }}</span>
      <button
        mat-stroked-button
        type="button"
        class="run-parameters__retry"
        data-testid="module-run-params-retry"
        (click)="load()"
      >
        {{ 'modules.run.parameters.retry' | translate }}
      </button>
    </div>
  }
  @default {
    <p class="run-parameters__source" data-testid="module-run-params-source">
      @if (sourceKind() === 'DATASHEET') {
        {{ 'modules.run.parameters.fromDatasheet' | translate: { name: sourceName() } }}
      } @else {
        {{ 'modules.run.parameters.fromDefaults' | translate }}
      }
    </p>

    @if (fields().length > 0 || missingSecrets().length > 0) {
      <section class="run-parameters" data-testid="module-run-params" [attr.aria-labelledby]="labelId">
        <span class="run-parameters__label" [id]="labelId">{{ 'modules.run.parameters.label' | translate }}</span>
        @for (parameter of fields(); track parameter.name; let i = $index) {
          @if (parameter.type === 'BOOLEAN') {
            <mat-slide-toggle
              class="run-parameters__toggle"
              [attr.data-testid]="'module-run-param-' + parameter.name"
              [checked]="valueOf(parameter.name) === 'true'"
              (change)="set(parameter.name, $event.checked ? 'true' : 'false')"
            >
              {{ parameter.name }}
            </mat-slide-toggle>
          } @else {
            <mat-form-field
              appearance="fill"
              floatLabel="always"
              class="run-parameters__field tc-field--uppercase-label"
            >
              <mat-label>{{ parameter.name }}</mat-label>
              <input
                matInput
                required
                [attr.autocomplete]="parameter.secret ? 'new-password' : 'off'"
                [id]="fieldId(i)"
                [type]="inputType(parameter)"
                [attr.maxlength]="fieldLengths.FREETEXT_MAX"
                [attr.data-testid]="'module-run-param-' + parameter.name"
                [value]="valueOf(parameter.name)"
                (input)="set(parameter.name, $any($event.target).value)"
              />
            </mat-form-field>
          }
        }
        @if (missingSecrets().length > 0) {
          <p class="run-parameters__secret-hint" role="note" data-testid="module-run-params-secret-hint">
            {{ 'modules.run.parameters.secretAutomated' | translate: { names: missingSecrets().join(', ') } }}
          </p>
        }
      </section>
    }
  }
}
